// <lema-posture posture="AI_POSTURE_..."> → badge. Unknown values → UNSPECIFIED (no badge).
import * as React from 'react'

import { AIPosture } from '@/gen/inventory/v1/ai_posture_pb'

import { AIPostureBadge } from '@/components/shared/ai-posture-badge/ai-posture-badge'

// Clean name→value map; the raw enum has reverse mappings (AIPosture["0"] → string).
const AI_POSTURE_BY_NAME = Object.fromEntries(
  Object.entries(AIPosture).filter(
    (entry): entry is [string, AIPosture] => typeof entry[1] === 'number',
  ),
)

const parseAIPosture = (name?: string): AIPosture =>
  (name && AI_POSTURE_BY_NAME[name]) || AIPosture.AI_POSTURE_UNSPECIFIED

export const LemaPosture = ({
  posture,
}: React.HTMLAttributes<HTMLSpanElement> & { posture?: string }) => (
  <AIPostureBadge posture={parseAIPosture(posture)} />
)
